import { Notifications } from '@intigral/shared';
import { Outlet } from 'react-router-dom';
import OverlayPortal from '../components/elements/OverlayPortal';
import Popup from '../components/elements/Popup';
import RefreshTokenErrorDialog from '../components/RefreshTokenErrorDialog';
import { RouteCondition, RouteGuard } from './guard';
import { UserStatus } from '../components/ui/UserStatus';
import { Footer } from './Footer';
import GenesysChatbox from '../components/ui/Genesys';
import { Header } from '../features/header';

const MenuLayout = ({ conditions, context }: { conditions: RouteCondition[]; context: any }) => {
    return (
        <RouteGuard conditions={conditions} context={context}>
            <Header />
            <Outlet />
            <Footer />
            <Popup />
            {/* will refactor OverlayPortal */}
            <OverlayPortal />
            <RefreshTokenErrorDialog />
            <Notifications />
            <GenesysChatbox />
            <UserStatus />
        </RouteGuard>
    );
};

export default MenuLayout;
